type FontSize = 'normal' | 'tiny' | 'small' | 'h1' | 'h2' | 'h3' | 'h4';
type ScreenType = 's' | 'm' | 'l' | 'xl' | 'xxl';

const fontBySize = {
  s: { h1: 18 * 1.2, h2: 18, h3: 16, h4: 14, normal: 13, small: 11, tiny: 9 },
  m: { h1: 21 * 1.2, h2: 21, h3: 18, h4: 16, normal: 15, small: 13, tiny: 11 },
  l: { h1: 22 * 1.2, h2: 22, h3: 20, h4: 18, normal: 16, small: 14, tiny: 12 },
  xl: { h1: 27 * 1.2, h2: 27, h3: 24, h4: 20, normal: 18, small: 15, tiny: 13 },
  xxl: {
    h1: 38 * 1.2,
    h2: 38,
    h3: 30,
    h4: 23,
    normal: 21,
    small: 17,
    tiny: 14,
  },
};

const lineHeightBySize = {
  s: { h1: 36, h2: 24, h3: 22, h4: 21, normal: 21, small: 17, tiny: 15 },
  m: { h1: 40, h2: 27, h3: 24, h4: 25, normal: 24, small: 19, tiny: 17 },
  l: { h1: 46, h2: 28, h3: 26, h4: 27, normal: 26, small: 20, tiny: 18 },
  xl: { h1: 56, h2: 33, h3: 30, h4: 33, normal: 29, small: 21, tiny: 19 },
  xxl: { h1: 78, h2: 44, h3: 36, h4: 47, normal: 34, small: 23, tiny: 20 },
};

const getScreenType = (): ScreenType => {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const screenArea = windowWidth * windowHeight;

  if (screenArea > 2073600) return 'xxl'; // > 1920x1080
  if (screenArea > 1440000) return 'xl'; // > 1600x900
  if (screenArea > 921600) return 'l'; // > 1280x720
  if (screenArea > 518400) return 'm'; // > 960x540
  return 's';
};

export const getFontSizeForScreen = (size: FontSize): number => {
  const screenType = getScreenType();
  return fontBySize[screenType][size] * 1.3;
};

export const getLineHeightForScreen = (size: FontSize): number => {
  return getFontSizeForScreen(size);
  const screenType = getScreenType();
  return fontBySize[screenType][size] * 1.2;
};
